import React from "react";
import LegalNotice from "./LegalNotice";

export default function TermsOfUse() {
  return (
    <div
      style={{
        maxWidth: "820px",
        margin: "0 auto",
        padding: "32px 18px 60px",
        color: "#0f172a",
        lineHeight: 1.65,
      }}
    >
      <h1 style={{ fontSize: "28px", fontWeight: 900, marginBottom: "12px" }}>
        Terms of Use
      </h1>

      <p style={{ color: "#475569", fontSize: "14px" }}>
        Last updated: {new Date().toLocaleDateString()}
      </p>

      <section>
        <h2>1. Educational Use Only</h2>
        <p>
          Gildarc provides general educational information about tax rules,
          benefits, and financial concepts. Gildarc is not tax advice, legal
          advice, or tax preparation software.
        </p>
      </section>

      <section>
        <h2>2. Not Tax Preparation or Filing</h2>
        <p>
          Gildarc does not prepare or file tax returns, does not submit
          information to the IRS, and does not represent users before any tax
          authority. Any outputs are educational explanations based on the
          information you enter.
        </p>
      </section>

      <section>
        <h2>3. No Guarantees</h2>
        <p>
          Tax eligibility and outcomes depend on specific facts and may change
          over time. Gildarc does not guarantee accuracy, completeness, or
          eligibility for any credit, deduction, or refund.
        </p>
      </section>

      <section>
        <h2>4. Your Responsibility to Verify</h2>
        <p>
          You are responsible for verifying information using official IRS
          instructions and other authoritative sources, and for seeking
          qualified professional help when appropriate.
        </p>
      </section>

      <section>
        <h2>5. Acceptable Use</h2>
        <p>
          You agree not to misuse the platform, attempt to break security,
          scrape content at scale, or use the site for unlawful purposes.
        </p>
      </section>

      <section>
        <h2>6. Intellectual Property</h2>
        <p>
          The content, design, and educational flows on Gildarc are owned by
          Gildarc and protected by applicable intellectual property laws. You
          may use the platform for personal educational purposes.
        </p>
      </section>

      <section>
        <h2>7. Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, Gildarc will not be liable for
          any indirect, incidental, special, consequential, or punitive damages,
          or any loss of profits or revenues, arising from your use of the
          platform or reliance on educational content.
        </p>
      </section>

      <section>
        <h2>8. Changes</h2>
        <p>
          We may update these Terms from time to time. Changes will be posted on
          this page with an updated date.
        </p>
      </section>

      <section>
        <h2>9. Contact</h2>
        <p>
          For questions, refer to the contact information provided on the site.
        </p>
      </section>

      <LegalNotice variant="footer" align="center" />
    </div>
  );
}
